'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useAuth } from '@/contexts/AuthContext'

export default function Home() {
  const router = useRouter()
  const { isLoggedIn } = useAuth()

  useEffect(() => {
    if (isLoggedIn) {
      router.push('/user/dashboard') // ログイン済みの場合はダッシュボードページへ
    } else {
      router.push('/login') // 未ログインの場合はログインページへ
    }
  }, [router, isLoggedIn])

  // リダイレクト中は何も表示しない
  return null
}
